export default "__VITE_ASSET__CdQcCXGK__"